<template>
  <el-icon :size="props.size" v-if="props.value == '男'">
    <Male color="#1e90ff" />
  </el-icon>
  <el-icon
    :size="props.size"
    v-else-if="props.value == '女'"
  >
    <Female color="#f00" />
  </el-icon>
  <template v-else>
    <text v-if="showEmpty">-</text>
  </template>
</template>

<script>
import { onMounted, reactive } from "vue";
export default {
  props: {
    value: String,
    showEmpty: Boolean, //如果值不匹配，则显示横杠
    size: {
      type: Number,
      default: 14,
    },
  },
  setup(props) {
    const state = reactive({});
    onMounted(() => {});
    return { state, props };
  },
};
</script>

<style lang="less" scoped></style>
